import { FirebaseDbProvider } from '../../providers/firebase-db/firebase-db';
import { Component } from '@angular/core';

@Component({
  selector: 'app-coach-marks',
  templateUrl: 'coach-marks.component.html'
})
export class CoachMarksComponent {

  en_text = {
    dashboardInfo: [
      `<b style="font-size: 1.2rem">Settings</b>. Here you will be able to manage your
        account (change password and username or log out) and to change the language of app.`,
      `<b style="font-size: 1.2rem">Stats</b>. Your <b>test progress</b> will be shown on
        these graphs.`,
      `<b style="font-size: 1.2rem">Practice</b>. In this section you will practice the
        writing of all the characters of the selected topic as many times as you want,
        without penalization.`,
      `<b style="font-size: 1.2rem">Test</b>. In the tests you will be asked a series of
        timed questions, in which you will have to write, as accurate as possible, the
        indicated character <b>based on its pronunciation.</b>`
    ],
    practice: [
      `<b style="font-size: 1.2rem">Randomize</b>. By default, characters will be displayed
        sequencially (as they are on the previous list). If you tap on the button, the characters
        will be shown in random order.`,
      `<b style="font-size: 1.2rem">List</b>. If you tap on this icon, a list containing all
        the chosen syllabary characters will appear, in which you can choose your desired
        character to draw.`,
      `<b style="font-size: 1.2rem">Change</b>. This icon allows to change between the two
        syllabaries: Hiragana and Katakana anytime you want.`,
      `<b style="font-size: 1.2rem">Information</b>. You can navigate through the previous
        listed characters with both of the arrows on the sides.`,
      `<b style="font-size: 1.2rem">Information</b>. If you tap on the character, a window
        will pop showing the stroke order of the character to follow, in order to write it in
        the proper way.`,
      `<b style="font-size: 1.2rem">Information</b>. Here the information of the chosen
        character is displayed, like the strokes and the pronunciation, <b>which is what you
        will be asked on the tests</b>.`,
      `<b style="font-size: 1.2rem">Canvas</b>. Here you can draw the indicated character.
        <b>Try to cover all the canvas when drawing.</b>`,
      `<b style="font-size: 1.2rem">Control</b>. With these two buttons you will be able to
        <b>clear the canvas</b> for redrawing the character or <b>to go to the next one</b>
        in order to continue drawing.`,
    ],
    test: [
      `<b style="font-size: 1.2rem">Repeat Test</b>. Here you will be able to repeat the
        test, but the results of the last one will not be saved.`,
      `<b style="font-size: 1.2rem">Results</b>. In this section the results of the test are
        displayed, indicating the number of correct and wrong questions.`,
      `<b style="font-size: 1.2rem">Details</b>. This is the obtained result based on your answer.
        You can click on the icon to see your answer.`,
      `<b style="font-size: 1.2rem">Details</b>. For every question, the correct answer is
        displayed along the question.`,
      `<b style="font-size: 1.2rem">Details</b>. And finally the slides, in which you can
        review your answers in order to compare them with the correct answers and see why you have
        failed.`,
      `<b style="font-size: 1.2rem">Save</b>. Once you have reviewed the results, they will
        be saved and you will return to the dashboard by tapping on this button.`
    ],
    buttons: [
      'Done',
      'Skip',
      'Next'
    ]
  };

  sp_text = {
    dashboardInfo: [
      `<b style="font-size: 1.2rem">Ajustes</b>. Aquí podrás administrar tu cuenta
        (cambiar la contraseña, tu nombre, cerrar sesión) y cambiar el idioma
        de la aplicación.`,
      `<b style="font-size: 1.2rem">Estadísticas</b>. Tus progresos de los tests se muestran
        en estas gráficas.`,
      `<b style="font-size: 1.2rem">Práctica</b>. En esta sección podrás practicar la escritura
        de los todos los caracteres tantas veces como quieras, sin penalización.`,
      `<b style="font-size: 1.2rem">Test</b>. En los tests se te harán una serie de preguntas
        con tiempo en donde tendrás que escribir perfectamente el carácter que se te indica <b>basado
        en la pronunciación de este.</b>`
    ],
    practice: [
      `<b style="font-size: 1.2rem">Modo Aleatorio</b>. Por defecto, los caracteres se mostrarán
        en orden según el silabario. Si se pulsa el botón, los caracteres se mostrarán en un orden
        aleatorio.`,
      `<b style="font-size: 1.2rem">Lista</b>. Si se pulsa en este icono, aparecerá la lista con
        todo el silabario correspondiente, en donde podrás elegir el carácter que quieras dibujar.`,
      `<b style="font-size: 1.2rem">Cambio</b>. Este icono permite cambiar, cuando quieras, de silabario
        entre Hiragana y Katakana.`,
      `<b style="font-size: 1.2rem">Información</b>. Podrás navegar por los distintos caracteres de
        la lista anterior con estas flechas posicionadas en ambos lados.`,
      `<b style="font-size: 1.2rem">Información</b>. Si pulsas en el carácter podrás acceder a una
        visualización del orden de los trazos para escribirlo correctamente.`,
      `<b style="font-size: 1.2rem">Información</b>. Aquí se muestra información acerca del carácter
        como los trazos y la pronunciación, <b>por lo que se preguntará en los tests</b>.`,
      `<b style="font-size: 1.2rem">Lienzo</b>. Aquí podrás dibujar el carácter lo mejor posible al
        indicado. <b>Asegúrate de cubrir todo el área al dibujar.</b>`,
      `<b style="font-size: 1.2rem">Control</b>. Con estos dos botones podrás o <b>borrar el lienzo
        </b> para redibujar el carácter o <b>pasar al siguiente carácter</b> para seguir dibujando.`
    ],
    test: [
      `<b style="font-size: 1.2rem">Repetir Test</b>. Aquí podrás volver a repetir el test, pero
        los resultados del anterior no se guardarán.`,
      `<b style="font-size: 1.2rem">Resultados</b>. En esta sección se muestran los resultados
        obtenidos, indicando el número de preguntas correctas y erróneas.`,
      `<b style="font-size: 1.2rem">Detalles</b>. Este es el resultado obtenido en base a tu respuesta.
        Puedes pulsar en el icono para ver tu respuesta.`,
      `<b style="font-size: 1.2rem">Detalles</b>. Aquí se muestra la respuesta correcta junto con la pregunta.`,
      `<b style="font-size: 1.2rem">Detalles</b>. Y por último el carrusel, en el que se
        pueden ver tus respuestas, para así compararlas con la respuestas correctas y revisar los fallos.`,
      `<b style="font-size: 1.2rem">Guardar</b>. Una vez revisados los resultados, se guardarán los
        resultados y volverás a la página principal pulsando este botón.`
    ],
    buttons: [
      'Hecho',
      'Saltar',
      'Siguiente'
    ]
  };

  constructor(private _db: FirebaseDbProvider) {}

  beginTutorial(tuto: any, lang: string, numSteps: string[], position: string[], page: string) {
    const stepsJson = [];
    for (let x = 0; x < numSteps.length; x++) {
      stepsJson.push({
        element: numSteps[x],
        intro: lang === 'en' ? this.en_text[page][x] : this.sp_text[page][x],
        position: position[x]
      });
    }

    tuto.setOptions({
      steps: stepsJson,
      showStepNumbers: false,
      showBullets: false,
      showProgress: true,
      hidePrev: true,
      hideNext: true,
      doneLabel: lang === 'en' ? this.en_text['buttons'][0] : this.sp_text['buttons'][0],
      skipLabel: lang === 'en' ? this.en_text['buttons'][1] : this.sp_text['buttons'][1],
      nextLabel: lang === 'en' ? this.en_text['buttons'][2] : this.sp_text['buttons'][2]
    });
    tuto.onafterchange(function (target: HTMLElement) {
      const id: string = target.id;
      const sel = document.querySelector('.introjs-tooltip') as HTMLElement;
      const arrow = document.querySelector('.introjs-arrow') as HTMLElement;
      if (id.includes('dashboard1') || id.includes('randomFinal') ||
        id.includes('topicHeader') || id.includes('resultsHead')) {
        sel.style.cssText = 'right: 0 !important; left: unset !important; top: 76px;';
        arrow.style.cssText = 'right: 37px !important;';
      } else {
        arrow.style.cssText = 'border: 0px !important';
      }
    }).start();
  }

  async getTuto(key: string) {
    return await this._db.retrieveUserData(key);
  }

  async updateTuto(key: string, field: string) {
    switch (field) {
      case 'results':
        await this._db.updateTutoRes(key);
        break;
      case 'canvas':
        await this._db.updateTutoCan(key);
        break;
    }
  }

}
